/**
 * Local Storage Manager
 */

const STORAGE_KEYS = {
  LANGUAGE: 'cropshield-language',
};

export const storageManager = {
  /**
   * Get saved language from localStorage
   * @returns {string} Saved language code or 'en' as default
   */
  getSavedLanguage: () => {
    return localStorage.getItem(STORAGE_KEYS.LANGUAGE) || 'en';
  },

  /**
   * Save language preference to localStorage
   * @param {string} language - Language code to save
   */
  saveLanguage: (language) => {
    localStorage.setItem(STORAGE_KEYS.LANGUAGE, language);
  },

  /**
   * Clear all stored data
   */
  clearAll: () => {
    localStorage.removeItem(STORAGE_KEYS.LANGUAGE);
  },
};
